import { IQuote } from '@types';

export const getQuoteQuantities = (key: 'pallet_qty' | 'qty' | 'weight' | 'total_weight' | 'total_volume', quote: IQuote) => {
	return quote?.quote?.cargos.reduce((total: number, obj: IQuote['quote']['cargo'][0]) => total + (obj[key] as number || 0), 0);
}